import { InfoField } from '@occc-app/design-system';
import { useConfig } from '@occc/config';

import { ConstraintFragment, Payment_Instrument_Evaluation_Method } from '@occc/graphql';
import { pluralize } from '@occc-app/lib/strings';
import { getConstraintsByType } from '../constraints-section.utils';
import { getPaymentInstrumentTitles } from '../../../component-details.utils';
import { formatValues } from '../../formatters';

export const PaymentInstrumentConstraint = ({
  constraints,
}: {
  constraints: ConstraintFragment[];
}) => {
  const supportedPaymentTypes = useConfig('supportedPaymentTypes') ?? [];
  const cst = getConstraintsByType('ConstraintPaymentInstrument', constraints);
  const allInstruments = [...new Set(cst.flatMap((c) => c.paymentInstruments ?? []))];

  const titles = formatValues(
    getPaymentInstrumentTitles({
      supportedPaymentTypes,
      paymentInstrumentsList: allInstruments,
    }),
  );

  const evaluationLabel =
    cst[0]?.paymentInstrumentEvaluationMethod === Payment_Instrument_Evaluation_Method.Exclude
      ? 'exclude'
      : '';

  return (
    <InfoField
      label={`${pluralize(allInstruments.length || undefined, 'Payment Type')} ${evaluationLabel}`}
      value={titles}
    />
  );
};
